import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "content", "label", "submenu", "toggleIcon", "logo", "logoImage"]
  static values = { collapsed: { type: Boolean, default: false } }

  connect() {
    if (localStorage.getItem("sidebar-collapsed") === "true") {
      this.collapsedValue = true
    }
    this.apply()
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    localStorage.setItem("sidebar-collapsed", this.collapsedValue)
    this.apply()
  }

  apply() {
    const collapsed = this.collapsedValue

    this.sidebarTarget.classList.toggle("lg:w-72", !collapsed)
    this.sidebarTarget.classList.toggle("lg:w-20", collapsed)

    this.contentTarget.classList.toggle("lg:pl-72", !collapsed)
    this.contentTarget.classList.toggle("lg:pl-20", collapsed)

    this.labelTargets.forEach(el => el.classList.toggle("lg:hidden", collapsed))
    this.submenuTargets.forEach(el => el.classList.toggle("lg:hidden", collapsed))

    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.toggle("rotate-180", !collapsed)
    }

    if (this.hasLogoTarget) {
      this.logoTarget.classList.toggle("max-w-8", collapsed)
    }

    this.logoImageTargets.forEach(el => {
      el.classList.toggle("h-9", !collapsed)
      el.classList.toggle("h-8", collapsed)
    })
  }
}
